(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  // Athos (Searchspring) hash filter used by subcollection cards: #/filter:tags:<tag>.
  // ss_subcollection_filter is the previous format, still matched so older links keep working.
  const HASH_TAG_FILTER = /(?:^|\/)filter:(?:tags|ss_subcollection_filter):([^/]+)/g;

  function decodeHashValue(value) {
    try {
      return decodeURIComponent(value.replace(/\+/g, ' '));
    } catch (e) {
      return value;
    }
  }

  // Helper: lowercase tag values of the Athos hash tag filters in a hash string
  function getHashTagFilters(hash) {
    return Array.from(hash.matchAll(HASH_TAG_FILTER), (match) => decodeHashValue(match[1]).toLowerCase());
  }

  function tagsMatch(a, b) {
    return a.includes(b) || b.includes(a);
  }

  // Helper: extract tag filter values from a URL string
  function getTagFiltersFromUrl(urlString) {
    try {
      const url = new URL(urlString, window.location.origin);
      const filters = new Set();
      url.searchParams.forEach((value, key) => {
        if (key.startsWith('filter.p.tag') || key === 'filter.p.tag[]') {
          filters.add(value.toLowerCase());
        }
      });
      // Support Athos (Searchspring) hash format: #/filter:tags:value
      getHashTagFilters(url.hash).forEach((tag) => filters.add(tag));
      // Support /tag/xxx path format
      const pathMatch = url.pathname.match(/\/tag\/([^/]+)/);
      if (pathMatch) {
        filters.add(decodeURIComponent(pathMatch[1]).toLowerCase());
      }
      // Support /collections/handle/tag-slug path format (e.g. /collections/shoes/hiking)
      const collectionTagMatch = url.pathname.match(/\/collections\/[^/]+\/([^/]+)/);
      if (collectionTagMatch) {
        filters.add(decodeURIComponent(collectionTagMatch[1]).toLowerCase());
      }
      return filters;
    } catch (e) {
      return new Set();
    }
  }

  // Helper: extract tag slug from a card's custom href
  function getTagSlugFromCardUrl(href) {
    if (!href) return null;
    try {
      const url = new URL(href, window.location.origin);
      
      // Support query parameters
      for (const [key, value] of url.searchParams.entries()) {
        if (key.startsWith('filter.p.tag') || key === 'filter.p.tag[]') {
          return value.toLowerCase();
        }
      }
      
      // Support Athos (Searchspring) hash format
      const [hashTag] = getHashTagFilters(url.hash);
      if (hashTag) return hashTag;
      
      // Path format: /collections/xxx/tag-slug
      const parts = url.pathname.split('/').filter(Boolean);
      if (parts.length >= 3) {
        return decodeURIComponent(parts[parts.length - 1]).toLowerCase();
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  // Mark active cards based on current URL filter state
  function updateActiveCollectionCards() {
    const currentFilters = getTagFiltersFromUrl(window.location.href);
    const cards = document.querySelectorAll('.collection-card__link'); // Check all cards, not just ajax ones
    cards.forEach((link) => {
      const card = link.closest('.collection-card');
      if (!card) return;
      const href = link.getAttribute('href');
      const tagSlug = getTagSlugFromCardUrl(href);
      if (tagSlug && currentFilters.size > 0) {
        // Check if this card's tag is active in the current URL
        const isActive = Array.from(currentFilters).some((f) => tagsMatch(f, tagSlug));
        card.classList.toggle('collection-card--active', isActive);
      } else {
        card.classList.remove('collection-card--active');
      }
    });
  }

  // Patch history API to detect AJAX URL changes (pushState / replaceState)
  // This fires when facets AJAX removes a filter chip and updates the URL
  if (!window.__collectionListHistoryPatched) {
    window.__collectionListHistoryPatched = true;
    const _push = history.pushState.bind(history);
    const _replace = history.replaceState.bind(history);

    history.pushState = function (...args) {
      _push(...args);
      window.dispatchEvent(new Event('urlchange'));
    };

    history.replaceState = function (...args) {
      _replace(...args);
      window.dispatchEvent(new Event('urlchange'));
    };
  }

  // Run on page load
  document.addEventListener('DOMContentLoaded', updateActiveCollectionCards);

  // Also run immediately (for cases where DOMContentLoaded already fired)
  updateActiveCollectionCards();

  // Handle click: apply filter AND update active state
  document.addEventListener('click', (event) => {
    // 1. Shopify native AJAX filter logic
    const link = event.target.closest('.collection-card__link[data-ajax-filter="true"]');
    if (link) {
      const customUrl = link.getAttribute('href');
      const facetsForm = document.querySelector('facets-form-component');
      if (facetsForm && customUrl) {
        event.preventDefault();
        const clickedCard = link.closest('.collection-card');

        if (clickedCard && clickedCard.classList.contains('collection-card--active')) {
          facetsForm.updateFiltersByURL(window.location.pathname);
          clickedCard.classList.remove('collection-card--active');
        } else {
          facetsForm.updateFiltersByURL(customUrl);

          // Optimistically update active card border immediately on click
          const allCards = document.querySelectorAll('.collection-card__link[data-ajax-filter="true"]');
          allCards.forEach((l) => {
            const c = l.closest('.collection-card');
            if (c) c.classList.remove('collection-card--active');
          });
          if (clickedCard) clickedCard.classList.add('collection-card--active');
        }
      }
      return;
    }

    // 2. Athos (Searchspring) filter logic
    const athosLink = event.target.closest('.collection-card__link:not([data-ajax-filter="true"])');
    if (athosLink) {
      const clickedCard = athosLink.closest('.collection-card');
      if (clickedCard && clickedCard.classList.contains('collection-card--active')) {
        event.preventDefault();
        // Remove only this card's tag filter, so other Athos tag filters stay applied
        const cardTag = getTagSlugFromCardUrl(athosLink.getAttribute('href'));
        const hash = window.location.hash;
        const newHash = hash
          .split('/')
          .filter((part) => {
            const [hashTag] = getHashTagFilters(part);
            return !hashTag || !cardTag || !tagsMatch(hashTag, cardTag);
          })
          .join('/');
        if (newHash !== hash) window.location.hash = newHash;
      }
    }
  });

  // Re-check on browser back/forward AND on AJAX URL changes (pushState/replaceState)
  window.addEventListener('popstate', updateActiveCollectionCards);
  window.addEventListener('urlchange', updateActiveCollectionCards);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
